import React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function Mobile({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.625 1.5H5.625C4.59 1.5 3.75 2.26364 3.75 3.20455V14.7955C3.75 15.7364 4.59 16.5 5.625 16.5H11.625C12.66 16.5 13.5 15.7364 13.5 14.7955V3.20455C13.5 2.26364 12.66 1.5 11.625 1.5V1.5ZM8.41842 15.648C7.91024 15.648 7.50003 15.2751 7.50003 14.8131C7.50003 14.3511 7.91024 13.9782 8.41842 13.9782C8.92659 13.9782 9.3368 14.3511 9.3368 14.8131C9.3368 15.2751 8.92659 15.648 8.41842 15.648V15.648ZM12.0001 13.0909H5.2501V3.54547H12.0001V13.0909V13.0909Z"
                fill={color}
            />
        </svg>
    );
}

export default Mobile;
